import { Base } from "../../framework/base";
import { IdColorTitle, IIdColorTitle } from "../common/idColorTitle";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { INumberTitle, NumberTitle } from "../common/numberTitle";

export interface IAppReportEventReferenceData {
    eventReports: IIdTitleNode[];
    eventUnits: IIdTitleNode[];
    eventStates: INumberTitle[];
    eventUrgencyClasses: IIdColorTitle[];
    eventTypes: IIdTitleNode[];
    eventTypeBs: IIdTitleNode[];
    eventTypeCs: IIdTitleNode[];
}

export class AppReportEventReferenceData implements IAppReportEventReferenceData {
    eventReports: IdTitleNode[];
    eventUnits: IdTitleNode[];
    eventStates: NumberTitle[];
    eventUrgencyClasses: IdColorTitle[];
    eventTypes: IdTitleNode[];
    eventTypeBs: IdTitleNode[];
    eventTypeCs: IdTitleNode[];

    constructor();
    constructor(obj: IAppReportEventReferenceData);
    constructor(obj?: any) {
        this.eventReports = Base.getTypedArray(obj?.eventReports, IdTitleNode);
        this.eventUnits = Base.getTypedArray(obj?.eventUnits, IdTitleNode);
        this.eventStates = Base.getTypedArray(obj ? obj.eventStates : null, NumberTitle);
        this.eventUrgencyClasses = Base.getTypedArray(obj ? obj.eventUrgencyClasses : null, IdColorTitle);
        this.eventTypes = Base.getTypedArray(obj ? obj.eventTypes : null, IdTitleNode);
        this.eventTypeBs = Base.getTypedArray(obj ? obj.eventTypeBs : null, IdTitleNode);
        this.eventTypeCs = Base.getTypedArray(obj ? obj.eventTypeCs : null, IdTitleNode);
    }
}
